import { render, staticRenderFns } from "./FinanceiroContratosForm.vue?vue&type=template&id=edc48f70&scoped=true"
import script from "./FinanceiroContratosForm.vue?vue&type=script&lang=js"
export * from "./FinanceiroContratosForm.vue?vue&type=script&lang=js"
import style0 from "./FinanceiroContratosForm.vue?vue&type=style&index=0&id=edc48f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc48f70",
  null
  
)

export default component.exports